import React, { useState } from 'react';
import './Disclaimer.css';

const DETAILED = `This website is a publication of VegaX Holdings Inc. ("VegaX"). Information presented is believed to be factual and up-to-date, but is not a guarantee of its accuracy and it should not be regarded as a complete analysis of the subjects discussed. All expressions of opinion reflect the judgment of the authors as of the date of publication and are subject to change. Information on this website does not involve the rendering of personalized investment advice or any offer to buy or sell, or a solicitation, or any offer to buy or sell any securities or financial products. Hyperlinks on this website are provided as a convenience and VegaX disclaims any responsibility for information, services or products found on websites linked hereto. The cryptocurrency industry is highly volatile and may represent significant risks.`;

const Disclaimer = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`disclaimer-bar${open ? ' open' : ''}`}> 
      <div className="disclaimer-header" onClick={() => setOpen(!open)}>
        <span className="disclaimer-title">Disclaimer</span>
        <img
          src="/disclaimer-arrow-down-light.svg"
          alt="Show disclaimer details"
          className={`disclaimer-arrow${open ? ' rotated' : ''}`}
          width={24}
          height={24}
        />
      </div>
      {open && (
        <div className="disclaimer-detail">
          <div className="disclaimer-text">{DETAILED}</div>
        </div>
      )}
    </div>
  );
};

export default Disclaimer; 